import { useMutation, useQuery } from "@tanstack/react-query";
import {
  billingApi,
  ListInvoicesQuery,
  ListInvoicesResponse,
  InvoiceDetail,
  InvoiceDownloadResponse,
} from "services/billingApi";

const DEFAULT_LIST_PARAMS: ListInvoicesQuery = { limit: 10 };

const invoicesKey = (params: ListInvoicesQuery) => [
  "billing",
  "invoices",
  params,
];

export const useInvoices = (params: ListInvoicesQuery = DEFAULT_LIST_PARAMS) =>
  useQuery<ListInvoicesResponse>({
    queryKey: invoicesKey(params),
    queryFn: () => billingApi.listInvoices(params),
    staleTime: 30_000,
  });

export const useInvoice = (invoiceId?: string) =>
  useQuery<InvoiceDetail | null>({
    queryKey: ["billing", "invoice", invoiceId],
    queryFn: () => (invoiceId ? billingApi.getInvoice(invoiceId) : null),
    enabled: Boolean(invoiceId),
  });

export const useInvoiceDownload = () =>
  useMutation<InvoiceDownloadResponse, unknown, string>({
    mutationFn: (invoiceId) => billingApi.getInvoiceDownloadUrl(invoiceId),
  });
